import type {
  ApiResponse,
  ChatConversationWithParticipants,
  ChatMessage,
  PaginatedResponse,
  SendMessagePayload,
} from '@klaro7/shared-types';

import api from '@/lib/api';

export async function getConversations(): Promise<ChatConversationWithParticipants[]> {
  const response = await api.get<ApiResponse<ChatConversationWithParticipants[]>>(
    '/chat/conversations'
  );
  return response.data.data;
}

export async function getMessages(
  conversationId: string,
  params?: { page?: number; limit?: number }
): Promise<PaginatedResponse<ChatMessage>> {
  const response = await api.get<PaginatedResponse<ChatMessage>>(
    `/chat/conversations/${conversationId}/messages`,
    { params }
  );
  return response.data;
}

export async function sendMessage(data: SendMessagePayload): Promise<ChatMessage> {
  const response = await api.post<ApiResponse<ChatMessage>>('/chat/messages', data);
  return response.data.data;
}

export async function markAsRead(conversationId: string): Promise<void> {
  await api.put(`/chat/conversations/${conversationId}/read`);
}

export async function markAsUnread(conversationId: string): Promise<void> {
  await api.put(`/chat/conversations/${conversationId}/unread`);
}

/** Consecutive messages sent without a reply in this conversation (anti-flood, no time window). */
export async function getUnansweredMessageCount(conversationId?: string): Promise<{ count: number; limit: number }> {
  const response = await api.get<ApiResponse<{ count: number; limit: number }>>(
    '/chat/daily-count',
    { params: conversationId ? { conversationId } : {} }
  );
  return response.data.data;
}
